import $ from 'jquery';

export default {
    classType: 'components',

    init() {
        this.el.addEventListener('change', () => {
            $('#timezone').find('option').remove();

            let countryId = $('#country').val();
            let timezones = appData.page.vars.timezones[countryId];

            $.each(timezones, function (index, timezone) {
                $('#timezone').append(
                    $('<option>', {
                        value: timezone,
                        text: timezone,
                    })
                );
            });
        });
    },
};
